import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import AdvisoryConsultForm from "./components/AdvisoryConsultForm";
import { Link } from "react-router-dom";
export default function AdvisoryPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Enterprise & advisory · Inquiries welcome"
          title="Your goals. A thoughtful way forward."
        >
          <p>
            Begin a conversation about enterprise, investor readiness, or
            cross-border collaboration. We’ll explore your priorities and
            discuss what support may be appropriate.
          </p>
          <a className="button button-green" href="#consult">
            Request a Consultation ↗
          </a>
        </PageIntro>
        <section className="section-space">
          <div className="shell">
            <p className="eyebrow">Where we can begin</p>
            <h2>Make the next step clearer.</h2>
            <div className="pillar-grid">
              {[
                {
                  title: "Enterprise planning",
                  text: "Clarify your business idea, the people it serves, and the capabilities or relationships you need to develop.",
                },
                {
                  title: "Investor readiness",
                  text: "Discuss your learning needs and the questions to resolve before considering investment opportunities.",
                },
                {
                  title: "Cross-border collaboration",
                  text: "Explore how African and diaspora experience can connect around a shared purpose, with local context at the center.",
                },
              ].map((x) => (
                <div className="pillar-card" key={x.title}>
                  <h3>{x.title}</h3>
                  <p>{x.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="section-space bg-[#F8F6F3]">
          <div className="shell purpose-grid">
            <h2>
              What happens after
              <br />
              you reach out?
            </h2>
            <div>
              <ol className="numbered-list">
                <li>Tell us about your goals and current stage.</li>
                <li>
                  Our team reviews your inquiry and follows up about fit and
                  availability.
                </li>
                <li>
                  Discuss scope, fees, and specialist requirements before
                  agreeing to any engagement.
                </li>
              </ol>
              <p className="body-copy">
                Submitting a request does not confirm an appointment or
                establish an advisory engagement. Family office and
                capital-related services are planned areas, subject to
                qualification and review.
              </p>
              <Link className="text-link" to="/services#service-scope">
                Read about service scope ↗
              </Link>
            </div>
          </div>
        </section>
        <AdvisoryConsultForm />
      </main>
      <Footer />
    </>
  );
}
